import React from "react";
import { DatePicker } from "@mui/x-date-pickers";

export interface IInputDatePicker {
  label: string;
  value: Date | null;
  setValue: (date: Date | null) => void;
  disabled?: boolean;
}

export const InputDatePicker: React.FC<IInputDatePicker> = ({
  label,
  value,
  setValue,
  disabled = false
}) => {
  return (
    <DatePicker
      label={label}
      value={value}
      disabled={disabled}
      onChange={(newValue) => setValue(newValue)}
      slotProps={{
        textField: {
          fullWidth: true
        }
      }}
    />
  );
};
